import {
  EmailShareButton,
  FacebookShareButton,
  PinterestShareButton,
  RedditShareButton,
  TwitterShareButton,
} from "react-share";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

import EmailOutlinedIcon from "@material-ui/icons/EmailOutlined";
import FacebookIcon from "@material-ui/icons/Facebook";
import TwitterIcon from "@material-ui/icons/Twitter";
import RedditIcon from "@material-ui/icons/Reddit";
import PinterestIcon from "@material-ui/icons/Pinterest";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    button: {
      margin: theme.spacing(1),
      color: theme.palette.primary.main,
    },
  })
);

interface SocialButonsProps {
  url: string;
  image?: string;
}

export default function SocialButtons(props: SocialButonsProps) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.button}>
        <TwitterShareButton url={props.url}>
          <TwitterIcon />
        </TwitterShareButton>
      </div>

      <div className={classes.button}>
        <FacebookShareButton url={props.url}>
          <FacebookIcon />
        </FacebookShareButton>
      </div>

      <div className={classes.button}>
        <PinterestShareButton
          media={props.image  || "/logo/logo_colored.svg"}
          url={props.url}
        >
          <PinterestIcon />
        </PinterestShareButton>
      </div>

      <div className={classes.button}>
        <RedditShareButton url={props.url}>
          <RedditIcon />
        </RedditShareButton>
      </div>

      <div className={classes.button}>
        <EmailShareButton url={props.url}>
          <EmailOutlinedIcon />
        </EmailShareButton>
      </div>
    </div>
  );
}
